import { Box, Grid2 } from '@mui/material'
import { varAlpha } from 'minimal-shared/utils'
import { memo } from 'react'

import Text from '../text/Text'

import homeBannerBg from 'assets/home-bg.png'
import FaIcon from '../shared/faIcon/FaIcon'
import { RouterLink } from '../../routes/components'
import Button from '../shared/button/Button'
import { buildHomeQuickMenu } from '../../layouts/nav-config-dashboard'

const AppWelcome = ({
  t,
  mainProfile,
  isQuestsEnabled,
  symbol,
  title,
  description,
  img,
  sx,
  ...other
}) => {
  return (
    <Box
      sx={[
        (theme) => ({
          ...theme.mixins.bgGradient({
            images: [
              `linear-gradient(to right, ${varAlpha(theme.vars.palette.grey['900Channel'], 0.88)} 0%, ${theme.vars.palette.grey[900]} 75%)`,
              `url(${homeBannerBg})`
            ]
          }),
          pt: 5,
          pb: 5,
          pr: 3,
          gap: 1,
          borderRadius: 2,
          display: 'flex',
          height: { md: 1 },
          position: 'relative',
          pl: { xs: 3, md: 5 },
          alignItems: 'center',
          color: 'common.white',
          textAlign: { xs: 'center', md: 'left' },
          flexDirection: { xs: 'column', md: 'row' },
          border: `solid 1px ${theme.vars.palette.grey[800]}`
        }),
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      {...other}
    >
      <Box
        sx={{
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          alignItems: { xs: 'center', md: 'flex-start' }
        }}
      >
        <Text
          variant='h4'
          sx={{ whiteSpace: 'pre-line', mb: 1 }}
          label={title}
        />

        <Text
          variant='body2'
          sx={{ opacity: 0.64, maxWidth: 360, mb: 3 }}
          label={description}
        />
        <Grid2
          container
          columnSpacing={1}
          rowSpacing={1}
          sx={{ justifyContent: { xs: 'center' }, mb: { xs: 2 } }}
        >
          {buildHomeQuickMenu({
            isQuestsEnabled,
            cashbackEarnOption: mainProfile.brandAppConfig.cashbackEarnOption,
            t,
            symbol
          }).map(({ title, path, icon }) => (
            <Grid2 size={{ xs: 'auto' }} key={title}>
              <Button
                label={title}
                startIcon={<FaIcon icon={icon} width={18} />}
                to={path}
                color='primary'
                component={RouterLink}
                size='small'
                sx={{
                  width: 'auto',
                  maxWidth: 150,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              />
            </Grid2>
          ))}
        </Grid2>
      </Box>
      {img}
    </Box>
  )
}

export default memo(AppWelcome)
